import { numberToCurrency } from "helpers/string"

/**
 * Calculates the total booking amount and breakdown
 */
export const calculateBookingTotal = (bookingSelections, counts, guideFeePercent) => {
  let total = 0
  const breakdown = []
  const { pricing_type, flat_rate, price_per_person, price_per_child, price_per_infant, price_per_passenger } =
    bookingSelections?.tripLength?.price || {}

  const getPrice = (specificPrice) => Number.parseFloat(specificPrice ?? 0) || 0

  const guestMapping = [
    { key: "adults", label: "Adult", price: price_per_person },
    { key: "children", label: "Child", price: price_per_child },
    { key: "infants", label: "Infant", price: price_per_infant },
    { key: "passengers", label: "Passenger", price: price_per_passenger }
  ]

  const mainCounts = counts?.main || {}
  if (pricing_type === "charge_flat_rate") {
    const flatAmount = getPrice(flat_rate)
    const hasMainGuests = Object.values(mainCounts).some((val) => val > 0)
    if (hasMainGuests) {
      total += flatAmount
      breakdown.push({
        label: "Flat Rate for Main Guests",
        amount: numberToCurrency(flatAmount)
      })
    }
  } else {
    for (const { key, label, price } of guestMapping) {
      const count = mainCounts[key] || 0
      if (count > 0) {
        const unitPrice = getPrice(price)
        const lineTotal = unitPrice * count
        total += lineTotal
        breakdown.push({
          label: `${label} x ${count}`,
          amount: numberToCurrency(lineTotal)
        })
      }
    }
  }

  const extraCounts = counts?.extra || {}
  for (const { key, label, price } of guestMapping) {
    const count = extraCounts[key] || 0
    if (count > 0) {
      const unitPrice = getPrice(price)
      const lineTotal = unitPrice * count
      total += lineTotal
      breakdown.push({
        label: `Extra ${label} x ${count}`,
        amount: numberToCurrency(lineTotal)
      })
    }
  }

  if (guideFeePercent && total > 0) {
    const taxAmount = (total * guideFeePercent) / 100
    total += taxAmount
    breakdown.push({
      label: `Tax & Fees`,
      amount: numberToCurrency(taxAmount)
    })
  }

  return { total, breakdown }
}
